(function($) {
    $.widget("ca.caDashboard", {
        options: {
            type: 'Main',
            itemId: 0,
            userId: 0,
            isEdit: true,
            posUserId: 0
        },

        _create : function() {
            var self = this;

            this.resizeColumns();

            if (self.options.type == 'Shop') {
                if (self.options.isFull == true) {
                    $('.ca-dashboard-header .header-add-buttons').hide();
                } else {
                    $('.ca-dashboard-header .header-add-buttons').show();
                }
            }

            if (self.options.isEdit) {
                $(function() {
                    self.element.find('.d-column').sortable({
                        connectWith: '.d-column',
                        start: function(event, ui) {
                            ui.item.addClass('d-block-move');
                        },
                        stop: function(event, ui) {
                            ui.item.removeClass('d-block-move');
                            if (ui.item.hasClass('d-block-wide')) {
                                var parent = ui.item.parent();
                                if (parent.hasClass('c-small')) {
                                    $(this).sortable('cancel');
                                }
                            }

                            self.resizeColumns();
                            self.saveDashboardOrdering();
                        },
                        revert: 250,
                        placeholder: 'd-block-highlight'
                    });

                    $('#sortable1, #sortable2, #sortable3').disableSelection();
                });

                self.element.find('.d-block').mouseenter(function() {
                    if ($(this).hasClass('d-block-wide')) {
                        self.element.find('.d-column').sortable('option', 'placeholder', 'd-block-highlight-wide');
                        self.element.find('.d-column').sortable('option', 'connectWith', '.c-wide');
                    } else {
                        self.element.find('.d-column').sortable('option', 'placeholder', 'd-block-highlight');
                        self.element.find('.d-column').sortable('option', 'connectWith', '.d-column');
                    }
                });
            }
        },

        resizeColumns: function() {
            var column = this.element.find('.d-column');
            column.height('auto');

            var maxHeight = 0;
            column.each(function() {
                maxHeight = Math.max(maxHeight, $(this).height());
            })

            column.height(maxHeight);
        },

        saveDashboardOrdering: function() {
            var self = this;

            var ids1 = $.map($('#sortable1 .d-block'), function(n, i) { return $(n).attr('id');});
            var ids2 = $.map($('#sortable2 .d-block'), function(n, i) { return $(n).attr('id');});
            var ids3 = $.map($('#sortable3 .d-block'), function(n, i) { return $(n).attr('id');});

            $.caAjax({
                type: 'post',
                url: '/dashboard/save-order',
                data: {
                    ids1: ids1,
                    ids2: ids2,
                    ids3: ids3,
                    userId: self.options.userId,
                    type: self.options.type,
                    itemId:  self.options.itemId,
                    page: $('.ca-dashboard').data('page') || 1
                },
                dataType: 'json',
                success: function(response) {
                    if (response.status == 1) {
                        self.updateDashboard(true);
                    } else {
                        $.caAlert(response.message);
                    }
                }
            });
        },

        deleteWidget: function(id) {
            var self = this;
            $.caPost('/dashboard/delete-widget', {user_id: this.options.userId, item_id: id}, function(response) {
                if (response.status == 1) {
                    self.updateDashboard(true);
                } else {
                    $.caAlert(response.message);
                }
            }, 'json');
        },

        getShopCategoryForm: function(id, item_id) {
            $.caPost('/shop/get-category-block', {id: id, item_id: item_id},
                function(response) {
                    if (response.content) {
                        $('.shop-category-block-form').caDialog('destroy').remove();
                        $(response.content).appendTo('body');
                        $('.shop-category-block-form').caDialog({
                            title: 'Edit a category',
                            resizable: false,
                            beforeClose: function () {
                                $(this).remove();
                            },
                            width: 400,
                            modal: true
                        });
                    } else if (response.status == 0) {
                        $.caAlert(response.message);
                    }
                },
                'json'
            );
        },

        getShopItemForm: function(id) {
            var itemId = $('.ca-dashboard').data('item-id') || 0;
            
            $.caPost('/shop/get-item-block', {id: id, item_id: itemId},
                function(response) {
                    if (response.content) {
                        $('.shop-item-block-form').caDialog('destroy').remove();
                        $(response.content).appendTo('body');
                        $('.shop-item-block-form').caDialog({
                            title: 'Edit an item',
                            resizable: false,
                            beforeClose: function () {
                                $(this).remove();
                            },
                            width: 400,
                            modal: true
                        });
                    } else if (response.status == 0) {
                        $.caAlert(response.message);
                    }
                },
                'json'
            );
        },

        getShopItemInfo: function(id, type) {
            var self = this;
            type = type || 'shop-item';
            $.caPost('/shop/get-item-info', {id: id, posUserId: self.options.posUserId, type: type},
                function(response) {
                    if (response.content) {
                        $('.shop-dashboard').caDialog('destroy').remove();
                        $('.shop-item-info-form').caDialog('destroy').remove();
                        $(response.content).appendTo('body');
                        $('.shop-item-info-form').caDialog({
                            title: response.title,
                            showCloseButton:true,
                            resizable: false,
                            beforeClose: function () {
                                $(this).remove();

                                $.caPost('/shop/manage-shortcuts', {isEdit:false, posUserId: self.options.posUserId},
                                    function(response) {
                                        if (response) {
                                            $(response).appendTo('body');
                                            $('.shop-dashboard').caDialog({
                                                title: 'Item Shortcuts',
                                                resizable: false,
                                                showCloseButton:true,
                                                beforeClose: function () {
                                                    $(this).remove();
                                                },
                                                width: 900,
                                                height: 'auto',
                                                modal: true
                                            });
                                            showResources($('#' + POSMenu.formId)[0], '/payment/right-side-view', 'pos_right_block');
                                        }
                                    }
                                );
                            },
                            open: function() {
                                var contentHeight = $('.si-options').height();
                                var tabHeight = $('.ca-tab').height();
                                var newHeight = contentHeight - tabHeight - 4;
                                $('.ca-panel-content').height(newHeight);
                            },
                            width: 700,
                            height: 'auto',
                            modal: true
                        });
                    } else if (response.status == 0) {
                        $.caAlert(response.message);
                    }
                },
                'json'
            );
        },

        getEditPosForm: function(id) {
            $.caGet('/dashboard/get-edit-pos-form', {item_id: id, user_id: this.options.userId},
                function(response) {
                    $('body').append(response);
                }
            );
        },

        getEditDummyForm: function(id) {
            $.caGet('/dashboard/get-edit-dummy-form', {item_id: id, user_id: this.options.userId},
                function(response) {
                    $('body').append(response);
                }
            );
        },

        getDashboard: function(id) {
            var self = this;
            var page = 1;
            if (self.options.page){
                page = self.options.page;
            }            
            var params = {
                isEdit: self.options.isEdit,
                nowrapper: 1,
                item_id: id,
                page: page,
                posUserId: self.options.posUserId
            };

            $.caPost('/shop/manage-shortcuts',
                params,
                function(response) {
                    $('#dashboard-wrapper').html(response);
                }
            );
        },

        updateDashboard: function(noWrapper) {
            var url = this.options.type == 'Main' ? '/?' : '/shop/manage-shortcuts?';
            if (this.options.isEdit == true) {
                url += '&edit=1';
            }

            if (noWrapper == true) {
                url += '&nowrapper=1';
            }
            
            var itemId = $('.ca-dashboard').data('item-id') || 0;
            var page = $('.ca-dashboard').data('page') || 1;

            $.caPost(url, {item_id: itemId, page: page, posUserId: this.options.posUserId}, function(response) {
                $('#dashboard-wrapper').html(response);
            })
        }
    });
})(jQuery);